import * as Types from './types'

export const fetchParamsFromState = (state: Types.FullComponentState) => {
  return {
    dateSelect: state.view.dateSelect.value,
    end: state.view.end,
    filter: state.view.filter.value,
    start: state.view.start,
  }
}

export const queryParamsToState = (params: any) => {
  const newFilter = Object.keys(params).includes('filter') ?
    {
      filter: {
        description: `Show ${params.filter} records`,
        key: 'status',
        value: params.filter,
      },
    }
    : {}

  const newdateSelect = Object.keys(params).includes('dateSelect') ?
    {
      dateSelect: {
        value: params.dateSelect,
      },
    }
    : {}

  return {...params,
    ...newFilter,
    ...newdateSelect}
}



// WEBPACK FOOTER //
// ./src/pages/training/utils.ts